// extracted by mini-css-extract-plugin
export default {"header":"YF","light":"ZF","dark":"aG","headertitle":"bG","fname":"cG","headerContent":"eG","right":"fG","descriptionwrapper":"gG","appear":"hG","second":"iG","third":"jG","forth":"kG"};
    if(module.hot) {
      // 1715188238418
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  